import React from "react";
import styled from "@emotion/styled";
import MenuButton from "@pages/myPage/_component/MenuButton";
import { useTranslation } from "react-i18next";
import { Flex, Tooltip } from "antd";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  // padding: "3rem 2rem",
  backgroundColor: "#F4F4F4",
});

const MenuContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  // gap: "3.2rem",
  backgroundColor: "#fff",
  padding: "2rem",
  gap: "3.2rem",
});

const MenuTitle = styled.h3(({ theme }) => ({
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.semiBold,
  color: theme.color.green,
}));

const MenuButtonList = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "3.2rem",
});

const CompanyInfoContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  padding: "2rem",
}));

const InfoTitle = styled.div(({ theme, lang }) => ({
  fontWeight: theme.fontWeight.semiBold,
  color: theme.color.gray,
  whiteSpace: lang === "en" ? "wrap" : "nowrap",
}));

const InfoText = styled.div(({ theme }) => ({
  color: theme.color.gray,
  lineHeight: "1.6",
}));

const Line = styled.div(({ theme }) => ({
  border: `1px solid ${theme.color.light_gray}`,
}));

interface IMenuChildren {
  title: string;
  route?: string;
  render?: () => React.ReactNode;
  externalLink?: string;
  state?: any;
}

interface IMenuType {
  title: string;
  children: IMenuChildren[];
}

interface IInfoPanel {
  defaultTab: string;
}
const InfoPanel = ({ defaultTab }: IInfoPanel) => {
  const { t } = useTranslation();
  const lang = window.localStorage.getItem("language");

  const menu = [
    {
      title: t("구독설정"),
      children: [
        {
          title: t("멤버쉽 플랜"),
          route: "/subscribe",
        },
      ],
    },
    {
      title: t("내 거래 관리"),
      children: [
        {
          title: t("주문 내역"),
          route: "/order-list",
        },
        {
          title: t("판매 내역"),
          route: "/sales-list",
        },
        {
          title: t("판매 정책 설정"),
          route: "/sales-policy",
        },
        {
          title: t("배송지관리"),
          route: "/delivery-management",
        },
        {
          title: t("계좌관리"),
          route: "/bank-account-management",
        },
        {
          title: t("구매/판매 문의"),
          route: "/sell-buy-inquiry",
        },
      ],
    },
    {
      title: t("고객서비스"),
      children: [
        {
          title: t("공지사항"),
          route: "/alarm",
          state: { activeTab: "2" },
        },
        {
          title: t("1:1 문의 / 제안 / 제보"),
          route: "/one-inquiry",
        },
        {
          title: t("FAQ"),
          route: "/faq",
        },
        {
          title: t("샤카라카 앱서비스 이용가이드"),
          externalLink:
            "https://owlsociety.notion.site/Guide-1335602230714890936174f5b62a91cd",
        },
        {
          title: t("이용약관"),
          externalLink:
            "https://owlsociety.notion.site/Terms-of-Use-f730e5a7ab0f4494b5bfc6b7322e8e56",
        },
        {
          title: t("개인정보 처리방침"),
          externalLink:
            "https://owlsociety.notion.site/c44be8e60e8f4589a5b8dc50ce22f6ad",
        },
      ],
    },
    {
      title: t("회원 정보 관리"),
      children: [
        {
          title: t("앱 설정"),
          route: "/setting",
        },

        {
          title: t("계정관리"),
          route: "/account-management",
          render: () => {
            return defaultTab === "2" ? (
              <Tooltip
                zIndex={0}
                title={t("비밀번호 변경")}
                placement="right"
                open={true}
                color="#FF4808"
                overlayInnerStyle={{
                  backgroundColor: "#FF4808",
                  borderRadius: "2px ",
                  height: "auto",
                  minHeight: "auto",
                  fontSize: "1.2rem",
                  fontFamily: "Pretendard",
                }}
              />
            ) : null;
          },
        },
      ],
    },
  ];

  return (
    <Container>
      {menu.map((menu: IMenuType, index: number) => (
        <MenuContainer key={index}>
          <MenuTitle>{menu.title}</MenuTitle>

          <MenuButtonList>
            {menu.children.map((children: IMenuChildren, index: number) => (
              <MenuButton
                key={index}
                title={children.title}
                route={children.route}
                render={children.render}
                externalLink={children.externalLink}
                state={children.state}
              />
            ))}
          </MenuButtonList>
        </MenuContainer>
      ))}

      {/* Footer */}
      <CompanyInfoContainer>
        <Flex gap={"1rem"}>
          <InfoTitle>{t("상호")}</InfoTitle>
          <InfoText>{t("주식회사 아울소싸이어티")}</InfoText>
        </Flex>

        <Flex gap={"1rem"}>
          <InfoTitle>{t("대표")}</InfoTitle>
          <InfoText>{t("곽지애")}</InfoText>
        </Flex>

        <Flex gap={"1rem"}>
          <InfoTitle>{t("전화")}</InfoTitle>
          <InfoText>010 7752 5785</InfoText>
        </Flex>

        <Flex gap={"1rem"}>
          <InfoTitle>{t("주소")}</InfoTitle>
          <InfoText>
            {t(
              "서울 종로구 종로 266 동대문종합시장B동 4층\ne-01호(종로6가, 동대문종합시장)",
            )}
          </InfoText>
        </Flex>

        <Line />

        <Flex gap={"1rem"}>
          <InfoTitle>{t("사업자등록번호")}</InfoTitle>
          <InfoText>681-87-02211</InfoText>
        </Flex>

        <Flex gap={"1rem"}>
          <InfoTitle lang={lang || "ko"}>{t("통신판매업 신고")}</InfoTitle>
          <InfoText>{t("제2022-수원팔달-0801")}</InfoText>
        </Flex>
      </CompanyInfoContainer>
    </Container>
  );
};

export default InfoPanel;
